import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/webinarSession'

export { selectors }

export default function useWebinarSession(selector) {
  return useSelector(state => selector(state.webinar), shallowEqual)
}
